import { c as _c } from "react/compiler-runtime";
import { findMatchingChildLabel } from "@components/common/faro-select/faro-select-utils";
import { DropdownSelect, FontWeights, Text } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
// TODO: Replace with flat-ui's DropdownSelect and delete this file: https://faro01.atlassian.net/browse/ST-5065
/**
 * Dashboard's select: flat-ui's `DropdownSelect` with the behaviour its call sites rely on - the
 * label only on `standard`, the info-bar value text on `standard` and the split-input geometry.
 * The rest of the look is flat-ui's own, including the `borderless` variant for table cells.
 */
export function FaroSelect(t0) {
  const $ = _c(17);
  const {
    value,
    variant,
    children,
    label,
    dataTestId,
    shouldShowFullWidth: t1,
    isSplitInput: t2,
    onChange,
    renderValue,
    menuProps,
    isDisabled: t3
  } = t0;
  const shouldShowFullWidth = t1 === undefined ? false : t1;
  const isSplitInput = t2 === undefined ? false : t2;
  const isDisabled = t3 === undefined ? false : t3;
  const t4 = typeof label === "string" ? label : undefined;
  const t5 = variant === "standard" ? label : undefined;
  const t6 = isSplitInput && variant === "outlined" ? SPLIT_INPUT_SX : undefined;
  let t7;
  if ($[0] !== children || $[1] !== renderValue || $[2] !== variant) {
    t7 = selected => {
      if (selected === undefined || selected === "") {
        return <Box component="span" />;
      }
      return <Text variant={variant === "borderless" ? "bodyS" : "bodyM"} component="span" sx={{
        ...(variant === "standard" && STANDARD_VALUE_SX),
        display: "block",
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }}>{renderValue?.(selected) ?? findMatchingChildLabel(children, selected) ?? selected}</Text>;
    };
    $[0] = children;
    $[1] = renderValue;
    $[2] = variant;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== children || $[5] !== dataTestId || $[6] !== isDisabled || $[7] !== menuProps || $[8] !== onChange || $[9] !== shouldShowFullWidth || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== value || $[15] !== variant) {
    t8 = <DropdownSelect dataTestId={dataTestId} aria-label={t4} label={t5} value={value} fullWidth={shouldShowFullWidth} variant={variant} onChange={onChange} menuProps={menuProps} disabled={isDisabled} sx={t6} renderValue={t7}>{children}</DropdownSelect>;
    $[4] = children;
    $[5] = dataTestId;
    $[6] = isDisabled;
    $[7] = menuProps;
    $[8] = onChange;
    $[9] = shouldShowFullWidth;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = value;
    $[15] = variant;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}

/**
 * The value text of the `standard` variant - matches the `FaroTextField` `main` fields it sits
 * next to in the info bars, and `MemberRoleReadOnly`'s read-only version of the same field.
 */
const STANDARD_VALUE_SX = {
  fontSize: "1.125rem",
  fontWeight: FontWeights.Bold,
  color: PALETTE_VARS.primary.main
};

/**
 * Joins the select to the text field on its left - `isSplitInput`: square inner corners and the two
 * borders overlapping. Both are flat-ui's 36px inputs, so their heights already match.
 */
const SPLIT_INPUT_SX = {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  marginLeft: "-1px"
};